import { MODAL } from '../../reduxs'
export const showValidate = (validate) => {
  return {
    type: MODAL.actionType.SHOW_VALIDATE,
    validate
  }
}

export const clearValidate = () => {
  return {
    type: MODAL.actionType.CLEAR_VALIDATE
  }
}
export const openModalStatus = (status) => {
  if (status.data == null) status.data = {}
  return {
    type: MODAL.actionType.OPEN_MODAL_STATUS,
    status: {
      status: !(status.data.error || status.data.error === undefined),
      ...status.data,
      ...status
    }
  }
}

export const closeModalStatus = () => {
  return {
    type: MODAL.actionType.CLOSE_MODAL_STATUS
  }
}

export const openModalConfirm = () => {
  return {
    type: MODAL.actionType.OPEN_MODAL_CONFIRM
  }
}

export const closeModalConfirm = () => {
  return {
    type: MODAL.actionType.CLOSE_MODAL_CONFIRM
  }
}

export const openModalCreate = () => {
  return {
    type: MODAL.actionType.OPEN_MODAL_CREATE
  }
}

export const closeModalCreate = () => {
  return {
    type: MODAL.actionType.CLOSE_MODAL_CREATE
  }
}

export const clearAll = () => {
  return {
    type: MODAL.actionType.CLEAR_DATA_MODAL
  }
}

export const openCrashMeetingModal = () => dispatch => {
  dispatch({ type: MODAL.actionType.OPEN_CRASH_MEETING_MODAL })
}

export const closeCrashMeetingModal = () => dispatch => {
  dispatch({ type: MODAL.actionType.CLOSE_CRASH_MEETING_MODAL })
}

export const openModalCrashBooking = () => dispatch => {
  dispatch({ type: MODAL.actionType.OPEN_MODAL_CRASH_BOOKING })
}

export const closeModalCrashBooking = () => dispatch => {
  dispatch({ type: MODAL.actionType.CLOSE_MODAL_CRASH_BOOKING })
}

export const openModalInformation = () => dispatch => {
  dispatch({ type: MODAL.actionType.OPEN_MODAL_INFORMATION })
}

export const closeModalInformation = () => dispatch => {
  dispatch({ type: MODAL.actionType.CLOSE_MODAL_INFORMATION })
}


export const openBookingDetailModal = () => dispatch => {
  dispatch({ type: MODAL.actionType.OPEN_BOOKING_DETAIL_MODAL })
}

export const closeBookingDetailModal = () => dispatch => {
  dispatch({ type: MODAL.actionType.CLOSE_BOOKING_DETAIL_MODAL })
}

export const openBookingMoreDetailModal = () => dispatch => {
  dispatch({ type: MODAL.actionType.OPEN_BOOKING_MORE_DETAIL_MODAL })
}

export const closeBookingMoreDetailModal = () => dispatch => {
  dispatch({ type: MODAL.actionType.CLOSE_BOOKING_MORE_DETAIL_MODAL })
}

// Order  Modal
export const setOrderCounterModal = (isOpenOrderCounterModal) => (dispatch) => {
  dispatch({ type: MODAL.actionType.SET_ORDER_COUNTER_MODAL, data: { isOpenOrderCounterModal } })
}

export const setConfirmOrderModal = (isOpenConfirmOrderModal) => (dispatch) => {
  dispatch({ type: MODAL.actionType.SET_CONFIRM_ORDER_MODAL, data: { isOpenConfirmOrderModal } })
}

export const setSuccessOrderModal = (isOpenSuccessOrderModal) => (dispatch) => {
  dispatch({ type: MODAL.actionType.SET_SUCCESS_ORDER_MODAL, data: { isOpenSuccessOrderModal } })
}

export const setCancelOrderModal = (isOpenCancelOrderModal) => (dispatch) => {
  dispatch({ type: MODAL.actionType.SET_CANCEL_ORDER_MODAL, data: { isOpenCancelOrderModal } })
}

export const setErrorOrderModal = (isOpenErrorOrderModal) => (dispatch) => {
  dispatch({ type: MODAL.actionType.SET_ERROR_ORDER_MODAL, data: { isOpenErrorOrderModal } })
}

export const setIssueReportModal = (isOpenIssueReportModal) => (dispatch) => {
  dispatch({ type: MODAL.actionType.SET_ISSUE_REPORT_MODAL, data: { isOpenIssueReportModal } })
}

export const setIssueFileLimitModal = (isOpenIssueFileLimitModal) => (dispatch) => {
  dispatch({ type: MODAL.actionType.SET_ISSUE_FILE_LIMIT_MODAL, data: { isOpenIssueFileLimitModal } })
}

// Extend meeting
export const openExtendMeetingModal = (isOpenExtendMeeting) => (dispatch) => {
  dispatch({ type: MODAL.actionType.OPEN_EXTEND_MEETING_MODAL, data: { isOpenExtendMeeting } })
}
export const closeExtendMeetingModal = (isOpenExtendMeeting) => (dispatch) => {
  dispatch({ type: MODAL.actionType.CLOSE_EXTEND_MEETING_MODAL, data: { isOpenExtendMeeting } })
}

export const setErrorModal = (isOpenErrorModal, textModal) => (dispatch) => {
  dispatch({ type: MODAL.actionType.SET_ERROR_MODAL, data: { isOpenErrorModal, textModal } })
}
